import { Image, Tooltip } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTheme } from 'styled-components';

import * as S from './style';
import { ThumbLoader } from './ThumbLoader';

function TableProducts({
  products = [],
  maxVisibleProducts = 3,
  onProductsClick = () => {},
  imageSize = { width: 32, height: 32 }
}) {
  const theme = useTheme();

  const productCount = products?.length || 0;
  const hasProducts = !!productCount;
  const previewProducts = products?.slice(0, maxVisibleProducts);
  const skeletonCount = productCount > maxVisibleProducts ? maxVisibleProducts : productCount;

  const productList = hasProducts ? (
    previewProducts?.map((product, index) => {
      if (productCount > maxVisibleProducts && index === maxVisibleProducts - 1) {
        return (
          <S.TableProductsLength
            type="button"
            key={`${product?.merchantProductId}${index}`}
            style={{
              width: imageSize.width,
              height: imageSize.height,
              fontSize: imageSize.width / 4 < 12 ? 12 : imageSize.width / 4
            }}
          >
            {`+${productCount - (maxVisibleProducts - 1)}`}
          </S.TableProductsLength>
        );
      }
      return (
        <Tooltip key={`${product?.merchantProductId}${index}`} content={product?.name} size="md">
          <Image
            src={product?.images[0]?.url}
            errorSrc={theme.images.noImage}
            alt={product?.name}
            width={imageSize.width}
            height={imageSize.height}
          />
        </Tooltip>
      );
    })
  ) : (
    <ThumbLoader count={skeletonCount} />
  );

  const gapSize = imageSize.width / 10;

  return (
    <S.TableProducts
      style={{
        width: maxVisibleProducts * (imageSize.width + (gapSize > 4 ? gapSize : 4))
      }}
      onClick={onProductsClick}
    >
      {!!productList && productList}
    </S.TableProducts>
  );
}

export { TableProducts };

TableProducts.S = S;
TableProducts.propTypes = {
  products: PropTypes.array,
  maxVisibleProducts: PropTypes.number,
  onProductsClick: PropTypes.func,
  imageSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  })
};
